import { SimpleGuard } from 'interfaces/guards'
import { getDevicesActionCreator } from 'actions/authActions'

export const devicesGuard: SimpleGuard<{}> = {
  name: 'Devices',
  checker: (state) => state.data.auth.devices !== null,
  loader: (dispatch) => dispatch(getDevicesActionCreator()),
}

